// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"_7j_zbjoRGkMQoHoJcL4u_","loginFailText":"_3wGWqy91OeiN76Jc90MLk2","formHolder":"_2gYCxdQ7gtMHdr0RS02tda","card":"_739aFBUTjUO2AmqMB0B8w"};